import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material";

const BoxWrapperstyle = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: "6px",
  padding: "30px 35px",
  "@media screen and (max-width:600px)": {
    width: "90%",
  },
  "& .topContent": {
    marginBottom: "30px",
    "& h4": { fontSize: "22px", marginBottom: "8px", color: theme.palette.text.primary, fontWeight: 600 },
    "& p": { fontSize: "16px", marginBottom: "8px", color: theme.palette.text.primary },
  },
  "& .BtnWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    "& button": {
      textTransform: "none",
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      borderRadius: "5px",
      boxShadow: "none",
      padding: "7px 22px",
      whiteSpace: "nowrap",
      width: "100%",
      "&:focus": {
        outline: "none",
      },
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
      "&.OutlineBtn": {
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        border: `2px solid ${theme.palette.primary.main}`,
        padding: "6px 22px",
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
          color: "#fff",
        },
      },
    },
  },
}));

export default function LogoutPopUp({ open, setOpen, onLogout }) {
  const handleClose = () => setOpen(false);
  const handleLogout = () => {
    setOpen(false);
    onLogout();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <BoxWrapperstyle>
          <Box className="topContent">
            <Typography component="h4">Logout</Typography>
            <Typography component="p">Are you sure you want to logout?</Typography>
          </Box>
          <Box className="BtnWrapper">
            <Button onClick={handleLogout}>Logout</Button>
            <Button className="OutlineBtn" onClick={handleClose}>
              Cancel
            </Button>
          </Box>
        </BoxWrapperstyle>
      </Fade>
    </Modal>
  );
}
